import { httpClient } from '@/modules/common/services/http/http-client';
import { TradeButton } from './types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/trading/`;
export const httpClientWithDefaultOptions = httpClient.withOptions({ baseURL });

export function getTradeButtons(): Promise<TradeButton[]> {
  return httpClientWithDefaultOptions.get('v2/buttons/service');
}
